import { FunctionComponent } from "react";
import styles from "./QuickAsystLogo.module.css";
import images from '../../../assets/images/index'
import { useNavigate } from "react-router";
const QuickAsystLogo: FunctionComponent = () => {
  const {QuickAsystLogo} = images;
  const navigate = useNavigate()
  return <img className={styles.QuickAsystIcon} alt="QuickAsystLogo" src={QuickAsystLogo} data-testid="QuickAsystLogo" onClick={()=> navigate('/login')} />;
};

export default QuickAsystLogo;
